import axios from 'axios';

const state = {
    EmailItems: [],
    LatestEmail:[],
    Loadings: {
        list: false,
    },
};

const getters = {
    LocationItems: (state) => state.LocationItems
};

const actions = {
    async getListEmails({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });
        return new Promise((resolve, reject) => {
            global.axios.get(`api/email/list`, { params: params })
                .then(response => {
                    commit('setLoadings', { key: "list", val: false });
                    commit('setListEmail', response.data.data);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async sendEmail({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });
        return new Promise((resolve, reject) => {
            let bodyFormData = new FormData();
            bodyFormData.append('to', params.to);
            bodyFormData.append('cc', params.cc);
            bodyFormData.append('subject', params.subject);
            bodyFormData.append('body', params.body);

            
            if (params.files !== null && params.files.length > 0) {
                for (var i = 0; i < params.files.length; i++) {
                    bodyFormData.append('files[]', params.files[i]);
                }
            }
            // bodyFormData.append('files[]', params.files[0]);
            // bodyFormData.append('files[]', params.files[1]);

            bodyFormData.append('caseId', params.caseId);
            bodyFormData.append('remark', params.remark);


            global.axios(`api/email/send-email`, {
                method: "POST",
                data: bodyFormData,
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then(response => {
                    // commit('addListEquipment',response);
                    resolve(response);
            }).catch(error => reject(error));
        });
    },
    async resendEmail({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });
        return new Promise((resolve, reject) => {
            let bodyFormData = new FormData();
            bodyFormData.append('email_ids', params.email_ids);
            

            global.axios(`api/email/resend-email`, {
                method: "POST",
                data: bodyFormData,
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then(response => {
                    resolve(response);
            }).catch(error => reject(error));
        });


    },
    async locked({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });
        return new Promise((resolve, reject) => {
            let bodyFormData = new FormData();
  


            bodyFormData.append('email_id', params.email_id);
            bodyFormData.append('locked', params.locked);
            if(!!params.status)
            {
                bodyFormData.append('status', params.status);
                bodyFormData.append('case_id', params.case_id);
                
                if(params.received_time){
                    bodyFormData.append('received_time', params.received_time);
                }
                
            }
            
            


            global.axios(`api/email/locked`, {
                method: "POST",
                data: bodyFormData,
                headers: { 'Content-Type': 'multipart/form-data' }
            })
                .then(response => {
                    // commit('addListEquipment',response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });

    },
    async checkLatestEmail({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });
        return new Promise((resolve, reject) => {
            global.axios.get(`api/email/check-latest-email/`+ params.email_id )
                .then(response => {
                    commit('setLoadings', { key: "list", val: false });
                    commit('setLatestEmail', response.data.data);
                    resolve(response);
                })
                .catch(error => reject(error));
        });

    },
    async latestEmail({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });
        return new Promise((resolve, reject) => {
            global.axios.get(`api/email/latest-email`, { params: params })
                .then(response => {
                    commit('setLoadings', { key: "list", val: false });
                    commit('setLatestEmail', response.data.data);
                    resolve(response);
                })
                .catch(error => reject(error));
        });

    },
    async files({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });

        return new Promise((resolve, reject) => {
            global.axios.get(`api/files`, { params: params })
                .then(response => {
                    // commit('setLoadings', { key: "list", val: false });
                    // commit('setLatestEmail', response.data.data);
                    // resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async searchContract({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });

        return new Promise((resolve, reject) => {
            global.axios.get(`api/email/search-contract`, { params: params })
                .then(response => {
                
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async EachEmail({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });

        return new Promise((resolve, reject) => {
            global.axios.get(`api/email/`+ params.email_id)
                .then(response => {
                
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async UpdateEmail({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });

        return new Promise((resolve, reject) => {
            global.axios.put(`api/email/`+ params.email_id,params)
                .then(response => {
                
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async UpdateEmailRead({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });

        return new Promise((resolve, reject) => {
            global.axios.put(`api/email/`+ params.email_id+`/read`,params)
                .then(response => {
                
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    }




};


const mutations = {
    setListEmail(state, data) {
        state.EmailItems = data;
    },
    setLatestEmail(state, data) {
        state.latestEmail=data;
    },
    setLoadings(state, data) {
        state.Loadings[data.key] = data.val;
    },
    

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}